import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Timeout, network ve HTTP hatalarını Error Boundary'de handle etme
    // Bunlar zaten global handler'da yakalanıyor
    if (error?.code === 'ECONNABORTED' || 
        error?.message?.includes('timeout') ||
        error?.code === 'ERR_NETWORK' ||
        error?.code === 'ERR_BAD_RESPONSE' ||
        error?.message?.includes('Network Error') ||
        error?.isAxiosError ||
        error?.response?.status) {
      return null; // Error Boundary'i tetikleme
    }
    
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Timeout, network ve HTTP hatalarını loglama
    if (error?.code === 'ECONNABORTED' || 
        error?.message?.includes('timeout') ||
        error?.code === 'ERR_NETWORK' ||
        error?.code === 'ERR_BAD_RESPONSE' ||
        error?.message?.includes('Network Error') ||
        error?.isAxiosError ||
        error?.response?.status) {
      console.warn('⚠️ Axios/HTTP hatası Error Boundary\'de yakalandı:', error);
      this.setState({ hasError: false }); // Hata state'ini sıfırla
      return;
    }
    
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
          <div className="bg-white rounded-xl shadow-lg p-4 max-w-4xl w-full">
            <div className="flex items-center justify-center mb-6">
              <div className="bg-red-100 rounded-full p-4">
                <AlertCircle className="w-12 h-12 text-red-600" />
              </div>
            </div>
            
            <h1 className="text-xl font-bold text-gray-900 text-center mb-4">
              Bir Hata Oluştu
            </h1>
            
            <p className="text-gray-600 text-center mb-6">
              Üzgünüz, beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="mb-6 p-4 bg-gray-100 rounded-lg overflow-auto max-h-64">
                <p className="text-sm font-mono text-red-600 mb-2">
                  {this.state.error.toString()}
                </p>
                {this.state.errorInfo && (
                  <pre className="text-xs text-gray-600 overflow-auto">
                    {this.state.errorInfo.componentStack}
                  </pre>
                )}
              </div>
            )}
            
            <div className="flex justify-center gap-3">
              <button
                onClick={this.handleReset}
                className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors font-medium"
              >
                <RefreshCw className="w-5 h-5" />
                Sayfayı Yenile
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
